import type { TFunction } from 'i18next'

export function formatPauseTime(
  pauseTimeMs: number,
  t: TFunction<'coaching'>,
): string {
  const totalSeconds = Number.isFinite(pauseTimeMs)
    ? Math.max(0, Math.floor(pauseTimeMs / 1000))
    : 0
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return minutes > 0
    ? t('video.pauseTimeMinutesSeconds', { minutes, seconds })
    : t('video.pauseTimeSeconds', { seconds })
}
